/**
 * <LiveMicVoice> — ma voix sur le bouton du micro (weekly du 03/11, W1) : les barres de ma vignette, en
 * petit, au pied du bouton, micro ouvert. Elles viennent de la même fente que celles des vignettes
 * (`VoiceSlotContext`) : sans fournisseur, ou sans voix, rien.
 */
import React, { type ReactNode } from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { TileVoice } from "../VideoTile/voiceSlot"

/** Des barres à la mesure d'un bouton de 48 : sous le glyphe, sans le toucher. */
const MIC_VOICE_SIZE = 8

export function LiveMicVoice(props: { voiceId: string | undefined; on: boolean; children: ReactNode }) {
    const { voiceId, on, children } = props
    // Toujours le même conteneur : le bouton du micro n'est jamais remonté quand la voix paraît ou part, et
    // garde le focus du clavier d'une bascule à l'autre.
    return (
        <View>
            {children}
            {on && voiceId != null && (
                <View style={styles.voice} pointerEvents="none">
                    <TileVoice participantId={voiceId} size={MIC_VOICE_SIZE} />
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    voice: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: theme.spacing["1"],
        alignItems: "center",
    },
}))
